<div class="imaging-requests-column custom-scrollbar">
  <div *ngFor="let imagingRequest of imagingRequests">
    <app-imaging-requests-tile
      [data]="imagingRequest"
      [userCanEditImagingRequests]="userCanEditimagingRequests"
    >
    </app-imaging-requests-tile>
  </div>
</div>
